export class OAuthPassport {
    public email: string = '';
    public oAuthToken: string = '';
    public oAuthProvider: string = '';
}
